/**
 * Central dayjs configuration. Imported once at app entry (main.tsx) so the
 * Persian locale + relativeTime plugin apply to every dayjs() call across the
 * app. dayjs is a singleton, so `dayjs.locale('fa')` here makes `.fromNow()`
 * render Persian ("۲ دقیقه پیش") instead of the English default.
 *
 * Individual modules may still `import dayjs from 'dayjs'` and call
 * `dayjs.extend(relativeTime)` defensively — extend is idempotent.
 */
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fa'

dayjs.extend(relativeTime)
dayjs.locale('fa')

export default dayjs
